<mat-card>
  <h2 translate>actionAgent.title</h2>
  <p translate>actionAgent.subtitle</p>
  <mat-card-content>
    <form [formGroup]="actionAgentForm" (ngSubmit)="consult()" fxFlex fxLayout="column nowrap">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroChainUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroChain"
            [cucumberId]="'macroChain'"
            [id]="'macroChainSelect'"
            [dataInput]="macroChainList"
            [placeholder]="'macrouser.title.groups'"
            [isRequired]="true"
            [showErrors]="actionAgentForm?.controls?.macroChain?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="isMacroOfficeUser || isBusinessDirector">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="macroOffice"
            [cucumberId]="'macroOffice'"
            [id]="'macroOfficeSelect'"
            [dataInput]="macroOfficeList"
            [placeholder]="'macrouser.title.offices'"
            [isRequired]="true"
            [showErrors]="actionAgentForm?.controls?.macroOffice?.errors"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" *ngIf="isMacroOfficeUser || isMacroChainUser"></div>
        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="division"
            [cucumberId]="'division'"
            [id]="'divisionSelect'"
            [dataInput]="divisionList"
            [placeholder]="'actionAgent.division'"
            [isRequired]="true"
            [showErrors]="actionAgentForm?.controls?.division?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="office"
            [cucumberId]="'office'"
            [id]="'officeSelect'"
            [dataInput]="officeList"
            [placeholder]="'actionAgent.office'"
            [showErrors]="actionAgentForm?.controls?.office?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="40">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="group"
            [cucumberId]="'chain'"
            [id]="'groupSelect'"
            [dataInput]="groupList"
            [placeholder]="'actionAgent.group'"
            [showErrors]="actionAgentForm?.controls?.group?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="nifcif"
            [cucumberId]="'prescriber'"
            [id]="'nifcifSelect'"
            [dataInput]="nifcifList"
            [placeholder]="'actionAgent.nifcif'"
            [showErrors]="actionAgentForm?.controls?.nifcif?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="30">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="pointOfSale"
            [cucumberId]="'establishment'"
            [id]="'pointOfSaleSelect'"
            [dataInput]="pointOfSaleList"
            [placeholder]="'actionAgent.pointOfSale'"
            [showErrors]="actionAgentForm?.controls?.pointOfSale?.errors"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="50" fxFlex.gt-sm="40">
          <scf-custom-select-search
            fxFlex="100"
            formControlName="externalCommercial"
            [cucumberId]="'externalCommercial'"
            [id]="'externalCommercialSelect'"
            [dataInput]="externalCommercialList"
            [placeholder]="'actionAgent.externalCommercial'"
            [showErrors]="actionAgentForm?.controls?.externalCommercial?.errors"
          >
          </scf-custom-select-search>
        </div>
      </div>

      <div fxFlex="100" fxFlex.gt-sm="100">
        <mat-radio-group formControlName="detail" [attr.data-cucumber-id]="'detail'">
          <mat-list>
            <mat-list-item>
              <mat-label fxFlex="100" translate>actionAgent.levelDetail</mat-label>
            </mat-list-item>
            <mat-list-item>
              <mat-radio-button
                [attr.data-cucumber-id]="'detail-' + radioButtonValues[0]"
                [value]="radioButtonValues[0]"
                >{{ 'actionAgent.group' | translate }}</mat-radio-button
              >
            </mat-list-item>
            <mat-list-item>
              <mat-radio-button
                [attr.data-cucumber-id]="'detail-' + radioButtonValues[2]"
                [value]="radioButtonValues[2]"
                >{{ 'actionAgent.dealer' | translate }}</mat-radio-button
              >
            </mat-list-item>
            <mat-list-item>
              <mat-radio-button
                [attr.data-cucumber-id]="'detail-' + radioButtonValues[1]"
                [value]="radioButtonValues[1]"
              >
                {{ 'actionAgent.pointOfSale' | translate }}
              </mat-radio-button>
            </mat-list-item>
          </mat-list>
        </mat-radio-group>
      </div>

      <div fxFlex="100" fxFlex.gt-sm="100">
        <div class="action-agent__card-footer">
          <button id="consultBtn" color="accent" type="submit" mat-flat-button [disabled]="actionAgentForm.invalid">
            <mat-label>{{ 'actionAgent.consult' | translate | uppercase }}</mat-label>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="hasNoOperation()">
  <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
    <mat-label class="panel-request__label-no-operation" translate>controlPanel.noOperations</mat-label>
  </div>
</mat-card>

<mat-card *ngFor="let item of table; let i = index">
  <mat-card-header class="action-agent__header">{{ item.title }}</mat-card-header>
  <mat-card-content>
    <div class="table__wrapper">
      <table aria-label="action-agent" mat-table [dataSource]="item.column">
        <!-- TOP HEADERS, we have separated it due to Angular not recognising different headers in the same container-->
        <ng-container matColumnDef="headersCurrent">
          <th mat-header-cell class="first-row" *matHeaderCellDef translate>actionAgent.term</th>
        </ng-container>
        <ng-container matColumnDef="totalCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][0] }}</th>
        </ng-container>
        <ng-container matColumnDef="januaryCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][1] }}</th>
        </ng-container>
        <ng-container matColumnDef="februaryCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][2] }}</th>
        </ng-container>
        <ng-container matColumnDef="marchCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][3] }}</th>
        </ng-container>
        <ng-container matColumnDef="aprilCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][4] }}</th>
        </ng-container>
        <ng-container matColumnDef="mayCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][5] }}</th>
        </ng-container>
        <ng-container matColumnDef="juneCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][6] }}</th>
        </ng-container>
        <ng-container matColumnDef="julyCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][7] }}</th>
        </ng-container>
        <ng-container matColumnDef="augustCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][8] }}</th>
        </ng-container>
        <ng-container matColumnDef="septemberCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][9] }}</th>
        </ng-container>
        <ng-container matColumnDef="octuberCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][10] }}</th>
        </ng-container>
        <ng-container matColumnDef="novemberCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][11] }}</th>
        </ng-container>
        <ng-container matColumnDef="decemberCurrent">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[0][12] }}</th>
        </ng-container>
        <!-- DATA -->
        <ng-container matColumnDef="headers">
          <th mat-header-cell class="first-row" *matHeaderCellDef translate>actionAgent.term</th>
          <th mat-header-cell class="first-row" *matHeaderCellDef translate>actionAgent.term</th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            [ngClass]="i === 0 ? 'first-row first-column narrow' : 'first-column narrow'"
          >
            {{ columns[i] | translate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][0] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[0] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="january">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][1] }}</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ element[1] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="february">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][2] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[2] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="march">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][3] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[3] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="april">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][4] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[4] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="may">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][5] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[5] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="june">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][6] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[6] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="july">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][7] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[7] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="august">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][8] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[8] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="september">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][9] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[9] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="october">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][10] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[10] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="november">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][11] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[11] | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="december">
          <th mat-header-cell *matHeaderCellDef>{{ item.header[1][12] }}</th>
          <td mat-cell *matCellDef="let element">{{ element[12] | transformNumber }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedCurrentColumns"></tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>

<mat-paginator
  *ngIf="table?.length > 0"
  id="id-paginator"
  class="action-agent__paginator"
  [pageSize]="pageSize"
  [length]="itemsLength"
  hidePageSize
  aria-label="select-page"
  (page)="onPageEvent($event)"
></mat-paginator>

<div class="action-agent__footer-buttons" fxLayoutAlign="end start" fxLayoutGap="16px" *ngIf="table.length > 0">
  <button
    id="createAllExcelPanel"
    mat-stroked-button
    color="accent"
    [disabled]="hasNoOperation()"
    (click)="exportExcel()"
  >
    <mat-icon class="icon-ic_file_download"></mat-icon>
    <span>{{ 'request.button.excel' | translate | uppercase }}</span>
  </button>
  <button id="createAllPdfPanel" mat-stroked-button color="accent" [disabled]="hasNoOperation()" (click)="print()">
    <mat-icon class="icon-ic_print"></mat-icon>
    <span>{{ 'request.button.print' | translate | uppercase }}</span>
  </button>
</div>
